function includesFilter(category, filter) {
  const categories = category.split(',');
  return categories.includes(filter);
}
const initJobFilter = ()=>{
  let currentFilter = null;
  const jobItems = document.querySelectorAll('.sand-job-item');
  const filterButtons = document.querySelectorAll('.sand-job-filter-btn');
  function filterBlocks(event) {
    const filterValue = event.target.dataset.filter;
    event.target.classList.toggle('sand-btn-active');
    filterButtons.forEach(filterBtn =>{
       if(filterBtn!==event.target){
         filterBtn.classList.remove('sand-btn-active')
       }
    })
    console.log(currentFilter, filterValue)
    if (currentFilter === filterValue) {
      jobItems.forEach((block) => {
        block.classList.remove('sand-item-inactive');
      });
      currentFilter = null;
    }else{
      jobItems.forEach((block) => {
        const blockCategory = block.dataset.cat;
        if (includesFilter(blockCategory,filterValue)){
          block.classList.remove('sand-item-inactive');
        } else {
          block.classList.add('sand-item-inactive');
        }
      });
      currentFilter = filterValue;
    }
  }

  if(jobItems.length > 0 && filterButtons.length > 0){
    filterButtons.forEach((button) => {
      button.addEventListener('click', filterBlocks);
    });
  }
}

export default initJobFilter;

